import React, { type PropsWithChildren, Suspense } from 'react';
import Container, { type ContainerProps } from '@mui/material/Container';
import RiskClassificationScaleBoundary from './RiskClassificationScaleBoundary';
import { RiskClassificationScaleProvider } from './RiskClassificationScaleContext';
import FullPageLoadingIndicator from 'components/v2/FullPageLoadingIndicator';
import useUIState from 'state/UI/hook';

const CreateOrUpdateAction = React.lazy(() => import('./Actions/CreateOrUpdateAction'));
const CreateOrUpdateCase = React.lazy(() => import('./Cases/CreateOrUpdateCase'));
const CreateOrUpdateComplaint = React.lazy(() => import('./Complaints/CreateOrUpdateComplaint'));
const SupplierCreateOrUpdate = React.lazy(() => import('./components/SupplierCreateOrUpdate'));
const QuestionnaireCreatorDialog = React.lazy(() => import('./Dashboard/RiskQuestionnaire/components/QuestionnaireCreatorDialog'));

const ContainerWrapper = ({ children, ...props }: PropsWithChildren<ContainerProps>) => {
   const {
      state: {
         questionnaireCreatorContext,
         showAddSupplierModal,
         showModalSupplierComplaintCreateOrEdit,
         showModalSupplierCaseCreateOrEdit,
         showModalSupplierActionCreateOrEdit,
      },
      updateUIState,
   } = useUIState();

   return (
      <RiskClassificationScaleProvider>
         <RiskClassificationScaleBoundary>
            <Container maxWidth="xl" {...props}>
               {children}
               {/* Modals */}
               {showAddSupplierModal ? (
                  <Suspense fallback={<FullPageLoadingIndicator />}>
                     <SupplierCreateOrUpdate />
                  </Suspense>
               ) : null}
               {showModalSupplierComplaintCreateOrEdit ? (
                  <Suspense fallback={<FullPageLoadingIndicator />}>
                     <CreateOrUpdateComplaint />
                  </Suspense>
               ) : null}
               {showModalSupplierCaseCreateOrEdit ? (
                  <Suspense fallback={<FullPageLoadingIndicator />}>
                     <CreateOrUpdateCase />
                  </Suspense>
               ) : null}
               {showModalSupplierActionCreateOrEdit ? (
                  <Suspense fallback={<FullPageLoadingIndicator />}>
                     <CreateOrUpdateAction />
                  </Suspense>
               ) : null}
               {questionnaireCreatorContext.open ? (
                  <Suspense fallback={<FullPageLoadingIndicator />}>
                     <QuestionnaireCreatorDialog
                        isOpen={questionnaireCreatorContext.open}
                        mode={questionnaireCreatorContext.mode}
                        questionnaire={questionnaireCreatorContext.entity}
                        onClose={() => {
                           updateUIState('questionnaireCreatorContext', {
                              mode: 'create',
                              open: false,
                              entity: null,
                           });
                        }}
                     />
                  </Suspense>
               ) : null}
            </Container>
         </RiskClassificationScaleBoundary>
      </RiskClassificationScaleProvider>
   );
};

export default ContainerWrapper;
